import List from "@/components/list";
import Bus from "./Bus.js";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  function handleDelete({ row }) {
    Bus.$emit("deleteArticle", row);
  }
  function handleView({ row }) {
    Bus.$emit("details", row);
  }
  function handleOnline({ row }) {
    Bus.$emit("online", row);
  }
  function handleOffline({ row }) {
    Bus.$emit("offline", row);
  }

  const Deal = ({ props: { vo } }) => {
    let dealConf = [
      ["icon-message", "查看详情", () => handleView(vo), "article:info"],
      ["icon-delete", "删除", () => handleDelete(vo), "article:delete"]
    ];
    if (vo.row.onlineStatus == 1) {
      dealConf.push([
        "icon-down",
        "下线",
        () => handleOffline(vo),
        "article:online"
      ]);
    } else {
      dealConf.push([
        "icon-up",
        "上线",
        () => handleOnline(vo),
        "article:online"
      ]);
    }
    // v-permission={item[2]}
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "文章标题",
      prop: "articleTitle",
      showOverflowTooltip: true
    },
    {
      label: "状态",
      prop: "onlineStatusName"
    },
    {
      label: "作者",
      prop: "authorName",
      showOverflowTooltip: true
    },
    {
      label: "文章类别",
      prop: "articleTypeName"
    },
    {
      label: "发表时间",
      prop: "createDate"
    },
    {
      label: "获得学分",
      prop: "score"
    },
    {
      label: "操作",
      fixed: "right",
      // align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
